import { useEffect, useState } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import { REPORTS_URL } from '../constans';
import {
  useGetItemByCodeQuery,
  useLazyGetDataByCodeQuery,
} from '../slices/simpleApiSlice';
import { Alert, Button, CircularProgress, LinearProgress } from '@mui/material';
import ListContainer from '../components/ListContainer';
import ReportSettings from '../components/Reports/Settings/ReportSettings';
import Alerton from '../components/Alerton';
import { DateTime } from 'luxon';
import TreeTable from '../components/Reports/Tree/TreeTable';
import ProjectViewerCard from '../components/ProjectViewerCard';
import { useSelector } from 'react-redux';
// import ItemViewer from '../components/Common/ItemViewer/ItemViewer';

const ReportScreen = () => {
  const navigate = useNavigate();
  const { id: code } = useParams();
  // Начальное состояние (если data пустая)
  // const [dateStart, setDateStart] = useState(
  //   // DateTime.now().minus({ months: 1 }).startOf('month').toISO(),
  //   DateTime.fromISO('2026-01-26T00:00:00.000Z').toISO(),
  // );
  // const [dateEnd, setDateEnd] = useState(DateTime.now().endOf('day').toISO());

  const [dateStart, setDateStart] = useState(
    DateTime.now().startOf('week').minus({ weeks: 1 }), // предыдущий понедельник 00:00
  );

  const [dateEnd, setDateEnd] = useState(
    DateTime.now()
      .startOf('week')
      .minus({ days: 1 }) // предыдущее воскресенье 00:00
      .endOf('day'), // → 23:59:59.999
  );

  const [alertMessage, setAlertMessage] = useState('');
  const [allSettings, setAllSettings] = useState([]);
  const [selectedSetting, setSelectedSetting] = useState('');
  const [lastSuccessfulReport, setLastSuccessfulReport] = useState(null);
  const tempSettings = useSelector((state) => state.auth.tempReportSettings);

  // useEffect(() => {
  //   if (allSettings) {
  //     console.log('allSettings', allSettings);
  //   }
  // }, [allSettings]);

  const { data, isLoading, isError, error } = useGetItemByCodeQuery({
    url: REPORTS_URL,
    code,
    providesTags: ['Report'],
  });

  // console.log('ReportScreen data', data);

  const [
    triggerReport,
    {
      data: reportData,
      isFetching: reportIsFetching,
      // error: reportError,
      isLoading: reportIsLoading,
    },
  ] = useLazyGetDataByCodeQuery();

  // useEffect(() => {
  //   console.log('ReportScreen.jsx reportData', reportData);
  // }, [reportData]);

  const [projectModal, setProjectModal] = useState({ open: false, id: null });

  const handleProjectClick = (projectId, projectName) => {
    setProjectModal({ open: true, id: projectId, name: projectName });
  };

  useEffect(() => {
    const set = [];
    let defaultSetting = data?.defaultSetting;
    // console.log('defaultSetting', defaultSetting);

    if (data?.allSettings) {
      set.push(...data.allSettings);
    }
    if (tempSettings?.[code]?.isTemp) {
      // console.log('Found tempSettings[code]', tempSettings[code]);
      const payload = { _id: 'new', title: 'Временная настройка' };
      set.push(payload);
      defaultSetting = payload;
    }
    setAllSettings(set);
    if (defaultSetting) setSelectedSetting(defaultSetting);
  }, [tempSettings, data]);

  useEffect(() => {
    // Даты из настроек (приоритет)
    if (data?.dateStart) {
      setDateStart(data.dateStart);
      // } else {
      //   // Начало предыдущего месяца (ISO строка)
      //   const startOfLastMonth = DateTime.now()
      //     .minus({ months: 1 })
      //     .startOf('month')
      //     .toISO();
      //   setDateStart(startOfLastMonth);
    }

    if (data?.dateEnd) {
      setDateEnd(data.dateEnd);
      // } else {
      //   // Текущая дата (конец дня)
      //   const endOfToday = DateTime.now().endOf('day').toISO();
      //   setDateEnd(endOfToday);
    }

    // // Последние 30 дней
    // const thirtyDaysAgo = DateTime.now()
    //   .minus({ days: 30 })
    //   .startOf('day')
    //   .toISO();

    // // Текущий месяц
    // const startOfMonth = DateTime.now().startOf('month').toISO();
    // const endOfMonth = DateTime.now().endOf('month').toISO();

    // // Предыдущая неделя
    // const startOfLastWeek = DateTime.now()
    //   .minus({ weeks: 1 })
    //   .startOf('week')
    //   .toISO();
  }, [data]);

  const handleRun = async () => {
    if (!selectedSetting?._id) {
      return setAlertMessage('Выберите настройку');
    }
    if (data?.item?.usePeriod && (!dateStart || !dateEnd)) {
      return setAlertMessage('Укажите период');
    }

    // ✅ RTK Query автоматически refetch с новыми params
    // Никаких дополнительных действий — data обновится сама!
    // setAlertMessage('Формируем отчёт...');

    try {
      const payload = {
        url: REPORTS_URL,
        code,
        dateStart,
        dateEnd,
        settingsId: selectedSetting._id,
        settingsData:
          selectedSetting._id === 'new'
            ? JSON.stringify(tempSettings[code])
            : null,
      };

      // console.log('triggerReport(payload)', payload);

      const result = await triggerReport(payload).unwrap(); // unwrap() для throw ошибок
      console.log('result', result);
      // Сохраняем успешный результат вместе с ID настройки
      setLastSuccessfulReport({
        settingId: selectedSetting._id,
        data: result,
      });
    } catch (err) {
      setAlertMessage(err?.data?.message || 'Ошибка отчёта');
    }
  };

  useEffect(() => {
    if (selectedSetting?._id === 'new') {
      handleRun();
    }
  }, [selectedSetting]);

  const goBack = () => {
    navigate('/reports/');
  };

  if (isLoading) {
    return <CircularProgress />;
  } else if (isError) {
    return (
      <Alert severity='warning'>
        {error?.data?.message || error?.error || error?.message || 'Error'}
      </Alert>
    );
  }

  return (
    <>
      <ListContainer goBack={goBack} title={data?.item?.title}>
        <ReportSettings
          report={data?.item}
          dateStart={dateStart}
          dateEnd={dateEnd}
          setDateStart={setDateStart}
          setDateEnd={setDateEnd}
          reportCode={code}
          allSettings={allSettings}
          selectedSetting={selectedSetting}
          setSelectedSetting={setSelectedSetting}
        />
        <Button variant='contained' onClick={handleRun} sx={{ my: 1 }}>
          Сформировать
        </Button>
        {(reportIsLoading || reportIsFetching) && <LinearProgress />}

        {lastSuccessfulReport &&
          lastSuccessfulReport.settingId === selectedSetting?._id && (
            <TreeTable
              onProjectClick={handleProjectClick}
              data={lastSuccessfulReport.data.data}
              tableConfig={lastSuccessfulReport.data.tableConfig}
              groupings={lastSuccessfulReport.data.groupings}
            />
          )}
      </ListContainer>
      <Alerton
        message={alertMessage}
        handleCloseMessage={() => setAlertMessage('')}
      />
      {/* Модалка */}
      <ProjectViewerCard
        open={projectModal.open}
        projectId={projectModal.id}
        projectName={projectModal.name}
        onClose={() => setProjectModal({ open: false })}
      />
    </>
  );
};

export default ReportScreen;
